import React from 'react';
import Carousel from './Carousel';
import DestinationSection from '../pages/DestinationSection';

import { Helmet } from 'react-helmet';
import PackageSection from '../pages/PackageSection';
import CallbackSection from '../pages/CallbackSection';
import ActivitySection from '../pages/ActivitySection';
import SpecialOffersSection from '../pages/SpecialOffersSection';
import TourGallerySection from '../pages/TourGallerySection';
import SubscribeSection from '../pages/SubscribeSection';
import BlogSection from '../pages/BlogSection';
import TestimonialSection from '../pages/TestimonialSection';


const HeroSection = () => {
  
  return (


    <div className="th-hero-wrapper hero-1" id="hero">



     
        <Carousel/>
      {/* <DestinationSection/> */}
      <PackageSection/>
      <CallbackSection/>
      <ActivitySection/>
      <SpecialOffersSection/>
      <TourGallerySection/>
      <SubscribeSection/>
      <BlogSection/>
      <TestimonialSection/>
    </div>
  );
};

export default HeroSection;
